import { lazy } from "react";

const TenantsPage = lazy(() => import("./pages/TenantsPage"));
const TenantDetailPage = lazy(() => import("./pages/TenantDetailPage"));
const CreateTenantPage = lazy(() => import("./pages/CreateTenantPage"));

export const tenantRoutes = [
  {
    path: "tenants",
    handle: { label: "Tenants", title: "Tenants", icon: "building-2", protected: true },
    children: [
      {
        index: true,
        element: <TenantsPage />,
      },
      {
        path: "new",
        element: <CreateTenantPage />,
        handle: { title: "Create Tenant", protected: true },
      },
      {
        path: ":slug",
        element: <TenantDetailPage />,
        handle: { title: "Tenant Details", protected: true },
      },
    ],
  },
];
